import { IMarketSummary, MarketMovement, MarketStatus } from './models';
import { CmcWebApi } from '@cmctechnology/webinvest-api-client-web-trading';
import { Exchange } from '@cmctechnology/webinvest-constants';

export const transformExchangeResponse = (model: CmcWebApi.MarketInformation.MarketStatusModel2, exchange: Exchange): IMarketSummary | undefined => {
  const indexDetails = model?.IndicesSummary?.Indices?.[0];
  const marketStats = model?.AsxMarketStatus;

  if (!indexDetails && !marketStats) {
    return undefined;
  }

  return {
    quoteTime: indexDetails?.QuoteTimeUi,
    open: marketStats?.MarketStatus?.toLowerCase() === MarketStatus.Open.toLowerCase(),
    up: indexDetails?.CssClass === MarketMovement.MarketUp,
    value: indexDetails?.Value,
    move: indexDetails?.Move,
    movePercent: indexDetails?.MovePercent,
    index: indexDetails?.Index,
    status: (marketStats?.MarketStatus ?? MarketStatus.Closed) as MarketStatus,
    code: indexDetails?.Code,
    exchangeTimestamp: marketStats?.TimeStamp?.valueOf()?.toString(),
    exchange
  };
};
